<template>
	<div class="menu-list-container">
		<el-menu
			default-active="4d82aa08-8c23-4414-aa34-c61239e0dcde"
			@open="handleOpen"
			@close="handleClose"
			class="el-menu-vertical-demo"
			text-color="#666"
			active-text-color="#274a7d"
			router
			unique-opened
		>
			<template v-for="(item, index) in menuList">
				<menu-item
					v-if="!item.child.length"
					:item="item"
					:key="'menu-item' + index"
				></menu-item>
				<sub-menu v-else :parent="item" :key="'sub-menu' + index">
					{{ item }}
				</sub-menu>
			</template>
		</el-menu>
	</div>
</template>

<script>
import SubMenu from './SubMenu1'
import MenuItem from './MenuItem1'
import Axios from 'axios'
export default {
	components: {
		SubMenu,
		MenuItem,
	},
	data() {
		return {
			menuList: [],
			show: false,
		}
	},
	watch: {},
	computed: {},
	methods: {
		getClick() {},
		handleOpen(key, keyPath) {
			this.$router.push('/solution/solutiondetail/' + key)
		},
		handleClose(key, keyPath) {
			this.$router.push('/solution/solutiondetail/' + key)
		},
	},
	created() {},
	mounted() {
			Axios({
			url: '/apiv2/bdoctree/gettree?bdContenttype=解决方案',
			data: {},
			method: 'GET',
		}).then((res) => {
			
			this.menuList = res.data.data
		})
	},
}
</script>
<style lang="scss" scoped>
.menu-list-container {
	.el-menu {
		border-right: none;
	}
}
::v-deep .el-submenu__title{
	height: 50px;
	line-height:50px;
}
::v-deep .el-menu {
	width: 300px;
}
::v-deep .el-menu-item{
	span{
		vertical-align: middle;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 200px;
	}
}
</style>

